import { classListSupport, hasClass } from './hasClass.js';
var addClass = classListSupport ?
    function (el, str) {
      if (!hasClass(el,  str)) { el.classList.add(str); }
    } :
    function (el, str) {
      if (!hasClass(el,  str)) { el.className += ' ' + str; }
    };

export { addClass };


//////////////////
// WEBPACK FOOTER
// ./~/tiny-slider/src/helpers/addClass.js
// module id = 837
// module chunks = 2